import HeaderMain from "../components/header/HeaderMain";
import NavMain from "../components/nav/NavMain";
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Col, Row, Form, FloatingLabel, Button, Modal, Table, Card } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { format } from 'date-fns';
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'; // Import the Select component
import GLOBALVAR from "../constants"; // Import GLOBALVAR constant
import LoadingSpinner from "../components/misc/LoadingSpinner";
import "../css/add-repayment.scss";

function AddRepayment() {
    const [value, setValue] = useState('');
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get('id');
    const [paymentDate, setPaymentDate] = useState(null); // Remove default payment date in initial state
    const [showModal, setShowModal] = useState(false);
    const [modalHeader, setModalHeader] = useState(null);
    const [modalBody, setModalBody] = useState(null);
    const [showSpinner, setShowSpinner] = useState(false);
    const [errMessages, setErrMessages] = useState(false);
    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);

    // Phase 3: Advanced Functions
    const handleShowSchedule = () => {
        setShowScheduleModal(true);
    };

    const handleAnalyticsToggle = () => {
        setShowAnalytics(!showAnalytics);
    };

    // Bulk Payments feature removed

    const handleQuickScenario = (scenarioPayment) => {
        const projections = calculatePaymentProjections(scenarioPayment);
        setPaymentProjections(projections);
        
        // Auto-fill the payment amount
        handleChangeInput({ target: { name: 'paidTotal', value: scenarioPayment.toString() } });
    };
    const [hasLoaded, setHasLoaded] = useState(false);
    const [paymentType, setPaymentType] = useState('');
    const [interestRate, setInterestRate] = useState(0); // Add new state for interest rate
    const [loanDetails, setLoanDetails] = useState({
        amountGranted: 0,
        loanTerm: 0,
        advanceInterest: true
    });
    const [currentLoan, setCurrentLoan] = useState(null);

    // New state for payment calculations
    const [paymentHistory, setPaymentHistory] = useState([]);
    const [outstandingAmounts, setOutstandingAmounts] = useState({
        principal: 0,
        interest: 0,
        totalPaid: 0,
        isCompleted: false
    });

    const [recentPayments, setRecentPayments] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalPayments, setTotalPayments] = useState(0);
    const [paymentsPerPage] = useState(10);
    const [recentPaymentsLoading, setRecentPaymentsLoading] = useState(false);
    const [penaltyData, setPenaltyData] = useState(null);

    // Phase 3: Advanced Features State
    const [paymentSchedule, setPaymentSchedule] = useState([]);
    const [showScheduleModal, setShowScheduleModal] = useState(false);
    // Bulk Payments feature removed
    const [showAnalytics, setShowAnalytics] = useState(false);
    const [, setPaymentProjections] = useState({});
    const [whatIfScenarios, setWhatIfScenarios] = useState([]);

    const [formData, setFormData] = useState({
        loanProcessingID: id ? id : '',
        paymentDate: '', // Remove default date
        prNumber: '',
        orNumber: '',
        paymentType: '',
        chequeNumber: '',
        paidPrincipal: '',
        paidInterest: '',
        paidPenalty: '',
        paidOther: '',
        paidTotal: ''
    });
    
    const [dateValidationError, setDateValidationError] = useState(false); // Add state for date validation error
    const [paymentTypeError, setPaymentTypeError] = useState(false);
    const [paidTotalError, setPaidTotalError] = useState(false);
    const [loanProcessingIDError, setLoanProcessingIDError] = useState(false); // Add new state for loanProcessingID validation

    const handleDateChange = (date) => {
        if (!date) {
            setDateValidationError(true);
            setPaymentDate(null);
            setFormData(prevState => ({
                ...prevState,
                paymentDate: ''
            }));
            return;
        }

        setDateValidationError(false);
        setPaymentDate(date);
        const formattedDate = format(date, 'MM/dd/yyyy');
        handleChangeInput({ target: { name: "paymentDate", value: formattedDate } });
    };

    // Function to fetch penalty data for a loan
    const fetchPenaltyData = useCallback(async (loanId) => {
        try {
            const response = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/penalties/loan/${loanId}`);
            
            // Process the response to calculate consolidated values (same logic as LoanPage)
            if (response.data && response.data.data) {
                const penaltyRecords = response.data.data;
                
                // Step 1: Filter unpaid penalties
                const unpaidPenalties = penaltyRecords.filter(penalty => !penalty.isPaid);
                
                // Step 2: Group unpaid penalties by lastPaymentDate
                const groupedByDate = {};
                unpaidPenalties.forEach(penalty => {
                    const paymentDate = penalty.lastPaymentDate || 'unknown';
                    if (!groupedByDate[paymentDate]) {
                        groupedByDate[paymentDate] = [];
                    }
                    groupedByDate[paymentDate].push(penalty);
                });
                
                // Step 3: Get only the latest record for each lastPaymentDate group
                const latestRecordsPerDate = Object.values(groupedByDate).map(group => {
                    return group.sort((a, b) => {
                        const dateA = new Date(a.createdAt || a.calculationDate);
                        const dateB = new Date(b.createdAt || b.calculationDate);
                        return dateB - dateA;
                    })[0];
                });
                
                // Step 4: Calculate total unpaid amount using the filtered records
                const totalUnpaidAmount = latestRecordsPerDate.reduce((sum, penalty) => {
                    const penaltyAmount = parseFloat(penalty.penaltyAmount || 0);
                    const paidAmount = parseFloat(penalty.paidAmount || 0);
                    return sum + (penaltyAmount - paidAmount);
                }, 0);
                
                // Calculate filtered total penalty amount
                const filteredTotalPenaltyAmount = latestRecordsPerDate.reduce((sum, penalty) => {
                    return sum + parseFloat(penalty.penaltyAmount || 0);
                }, 0);
                
                // Calculate filtered total paid amount
                const filteredTotalPaidAmount = latestRecordsPerDate.reduce((sum, penalty) => {
                    return sum + parseFloat(penalty.paidAmount || 0);
                }, 0);
                
                // Calculate the outstanding balance
                const outstandingBalance = filteredTotalPenaltyAmount - filteredTotalPaidAmount;
                
                // Enhanced penalty data
                const enhancedData = {
                    ...response.data,
                    consolidatedData: {
                        unpaidCount: latestRecordsPerDate.length,
                        totalUnpaidAmount: totalUnpaidAmount.toFixed(2),
                        outstandingBalance: outstandingBalance.toFixed(2),
                        filteredTotalPenaltyAmount: filteredTotalPenaltyAmount.toFixed(2),
                        filteredTotalPaidAmount: filteredTotalPaidAmount.toFixed(2),
                        oldestPenaltyDate: latestRecordsPerDate.length > 0 ? 
                            Math.min(...latestRecordsPerDate.map(p => new Date(p.calculationDate).getTime())) : null,
                        filteredRecords: latestRecordsPerDate
                    }
                };
                
                setPenaltyData(enhancedData);
                return enhancedData;
            } else {
                setPenaltyData(response.data);
                return response.data;
            }
        } catch (error) {
            console.error('Error fetching penalty data:', error);
            setPenaltyData(null);
            return null;
        }
    }, []);

    // Phase 3: Advanced Function - Generate Payment Schedule Preview
    const generatePaymentSchedule = useCallback((loan, startDate = new Date()) => {
        if (!loan || !loan.amountGranted) return [];

        const amountGranted = parseFloat(loan.amountGranted);
        const loanTerm = parseInt(loan.loanTerm);
        const rate = parseFloat(loan.interestRate || interestRate);
        const loanInterval = loan.loanInterval;
        const advanceInterest = loan.advanceInterest;

        const principalPerTerm = amountGranted / loanTerm;
        const initialInterest = amountGranted * (rate / 100);
        
        let interestPerTerm;
        if (advanceInterest) {
            const totalInterest = initialInterest * loanTerm;
            const advanceInterestPaid = initialInterest;
            const remainingInterest = totalInterest - advanceInterestPaid;
            interestPerTerm = remainingInterest / loanTerm;
        } else {
            interestPerTerm = initialInterest;
        }

        const schedule = [];
        let currentDate = new Date(startDate);
        let runningPrincipalBalance = amountGranted;

        // Helper function to add intervals
        const addInterval = (date, interval, count) => {
            const newDate = new Date(date);
            switch (interval.toLowerCase()) {
                case 'monthly':
                    newDate.setDate(newDate.getDate() + (31 * count));
                    break;
                case 'bimonthly':
                    newDate.setDate(newDate.getDate() + (14 * count));
                    break;
                case 'weekly':
                    newDate.setDate(newDate.getDate() + (7 * count));
                    break;
                case 'quarterly':
                    newDate.setMonth(newDate.getMonth() + (3 * count));
                    break;
                case 'semiannual':
                    newDate.setMonth(newDate.getMonth() + (6 * count));
                    break;
                case 'yearly':
                    newDate.setFullYear(newDate.getFullYear() + count);
                    break;
                default:
                    newDate.setMonth(newDate.getMonth() + count);
            }
            return newDate;
        };

        for (let i = 1; i <= loanTerm; i++) {
            currentDate = addInterval(startDate, loanInterval, i);
            
            const termPrincipal = Math.min(principalPerTerm, runningPrincipalBalance);
            runningPrincipalBalance -= termPrincipal;

            schedule.push({
                termNumber: i,
                dueDate: new Date(currentDate),
                principal: termPrincipal,
                interest: interestPerTerm,
                totalPayment: termPrincipal + interestPerTerm,
                remainingBalance: runningPrincipalBalance,
                status: 'pending' // Will be updated based on actual payments
            });
        }

        return schedule;
    }, [interestRate]);

    // Phase 3: Calculate Payment Projections
    const calculatePaymentProjections = useCallback((currentPayment) => {
        if (!loanDetails.amountGranted || !currentPayment) return {};

        const projections = {
            payoffDate: null,
            totalInterestSaved: 0,
            monthsReduced: 0,
            nextDueAmount: outstandingAmounts.recommendedPayment || 0
        };

        // Simple projection calculation
        if (outstandingAmounts.totalDue > 0 && currentPayment > 0) {
            const monthsToPayoff = Math.ceil(outstandingAmounts.totalDue / currentPayment);
            const payoffDate = new Date();
            payoffDate.setMonth(payoffDate.getMonth() + monthsToPayoff);
            projections.payoffDate = payoffDate;
        }

        return projections;
    }, [loanDetails, outstandingAmounts]);

    // Phase 3: What-If Scenario Analysis
    const calculateWhatIfScenarios = useCallback((snapshot) => {
        const data = snapshot || outstandingAmounts;
        if (!data.totalDue || data.totalDue <= 0) return [];

        const scenarios = [
            {
                name: 'Minimum Payment',
                payment: data.minimumPayment || 0,
                months: 0,
                totalInterest: 0,
                description: 'Pay minimum required amount'
            },
            {
                name: 'Recommended Payment',
                payment: data.recommendedPayment || 0,
                months: 0,
                totalInterest: 0,
                description: 'Stay current with recommended amount'
            },
            {
                name: 'Double Payment',
                payment: (data.recommendedPayment || 0) * 2,
                months: 0,
                totalInterest: 0,
                description: 'Pay double to accelerate payoff'
            },
            {
                name: 'Full Payoff',
                payment: data.totalDue,
                months: 0,
                totalInterest: 0,
                description: 'Pay entire remaining balance'
            }
        ];

        // Calculate months for each scenario
        scenarios.forEach(scenario => {
            if (scenario.payment > 0) {
                scenario.months = Math.max(1, Math.ceil((data.totalDue || 0) / scenario.payment));
            }
        });

        return scenarios;
    }, [outstandingAmounts]);

    // Removed unused calculateOutstandingAmounts (replaced by enhanced calculation)

    // Enhanced function to calculate actual payment due based on current date and due dates
    const calculateActualOutstanding = useCallback((loan, payments, penalties, asOfDate = new Date()) => {
        const amountGranted = parseFloat(loan.amountGranted);
        const loanTerm = parseInt(loan.loanTerm);
        const advanceInterest = loan.advanceInterest;
        const rate = parseFloat(loan.interestRate || interestRate);
        const loanInterval = loan.loanInterval;
        const startDate = new Date(loan.dateGranted);
        
        // Calculate initial amounts
        const principalPerTerm = amountGranted / loanTerm;
        const initialInterest = amountGranted * (rate / 100);
        
        let interestPerTerm;
        if (advanceInterest) {
            // For advance interest: remaining interest divided by terms
            const totalInterest = initialInterest * loanTerm;
            const advanceInterestPaid = initialInterest;
            const remainingInterest = totalInterest - advanceInterestPaid;
            interestPerTerm = remainingInterest / loanTerm;
        } else {
            // For non-advance interest: full interest per term
            interestPerTerm = initialInterest;
        }

        // Helper function to add intervals to date
        const addInterval = (date, interval, count) => {
            const newDate = new Date(date);
            switch (interval.toLowerCase()) {
                case 'monthly':
                    newDate.setDate(newDate.getDate() + (31 * count));
                    break;
                case 'bimonthly':
                    newDate.setDate(newDate.getDate() + (14 * count));
                    break;
                case 'weekly':
                    newDate.setDate(newDate.getDate() + (7 * count));
                    break;
                case 'quarterly':
                    newDate.setMonth(newDate.getMonth() + (3 * count));
                    break;
                case 'semiannual':
                    newDate.setMonth(newDate.getMonth() + (6 * count));
                    break;
                case 'yearly':
                    newDate.setFullYear(newDate.getFullYear() + count);
                    break;
                default:
                    newDate.setMonth(newDate.getMonth() + count);
            }
            return newDate;
        };

        // Generate due dates and calculate what should have been paid by asOfDate
        let termsDue = 0;
        let currentDate = new Date(startDate);
        
        for (let i = 1; i <= loanTerm; i++) {
            currentDate = addInterval(startDate, loanInterval, i);
            if (currentDate <= asOfDate) {
                termsDue = i;
            } else {
                break;
            }
        }

        // Calculate expected payments by asOfDate
        const expectedPrincipalByDate = principalPerTerm * termsDue;
        const expectedInterestByDate = interestPerTerm * termsDue;
        
        // Calculate actual payments made up to asOfDate (as-of logic)
        const paymentsAsOf = (payments || []).filter(p => {
            try { return new Date(p.paymentDate) <= asOfDate; } catch { return true; }
        });
        const totalPaidPrincipal = paymentsAsOf.reduce((sum, payment) => 
            sum + parseFloat(payment.paidPrincipal || 0), 0);
        const totalPaidInterest = paymentsAsOf.reduce((sum, payment) => 
            sum + parseFloat(payment.paidInterest || 0), 0);
        const totalPaidPenalty = paymentsAsOf.reduce((sum, payment) => 
            sum + parseFloat(payment.paidPenalty || 0), 0);
        const totalPaid = paymentsAsOf.reduce((sum, payment) => 
            sum + parseFloat(payment.paidTotal || 0), 0);

        // Calculate outstanding amounts
        const outstandingPrincipal = Math.max(0, expectedPrincipalByDate - totalPaidPrincipal);
        const outstandingInterest = Math.max(0, expectedInterestByDate - totalPaidInterest);
        
        // Compute penalties as-of asOfDate using penalty records up to that date minus penalty payments up to that date
        let outstandingPenalty = 0;
        try {
            if (penalties && Array.isArray(penalties.data)) {
                // Consider only penalty records calculated up to asOfDate
                const allRecords = penalties.data.filter(rec => {
                    const d = new Date(rec.calculationDate || rec.createdAt || rec.lastPaymentDate || Date.now());
                    return d <= asOfDate;
                });

                // Group by lastPaymentDate to get latest record per date (avoid double counting recalculations)
                const grouped = {};
                allRecords.forEach(rec => {
                    const key = rec.lastPaymentDate || 'unknown';
                    if (!grouped[key]) grouped[key] = [];
                    grouped[key].push(rec);
                });

                const latestPerDate = Object.values(grouped).map(group => group.sort((a, b) => {
                    const da = new Date(a.createdAt || a.calculationDate || 0);
                    const db = new Date(b.createdAt || b.calculationDate || 0);
                    return db - da; // newest first
                })[0]);

                const totalPenaltyAssessed = latestPerDate.reduce((sum, rec) => sum + parseFloat(rec.penaltyAmount || 0), 0);
                const paidPenaltyAsOf = paymentsAsOf.reduce((sum, p) => sum + parseFloat(p.paidPenalty || 0), 0);
                outstandingPenalty = Math.max(0, totalPenaltyAssessed - paidPenaltyAsOf);
            } else if (penalties && penalties.consolidatedData) {
                // Fallback to consolidated balance if records missing
                const paidAfter = (payments || []).filter(p => {
                    try { return new Date(p.paymentDate) > asOfDate; } catch { return false; }
                }).reduce((s, p) => s + parseFloat(p.paidPenalty || 0), 0);
                const currentOutstanding = parseFloat(penalties.consolidatedData.outstandingBalance || 0);
                outstandingPenalty = Math.max(0, currentOutstanding + paidAfter);
            } else {
                outstandingPenalty = 0;
            }
        } catch (e) {
            outstandingPenalty = penalties && penalties.consolidatedData ? 
                parseFloat(penalties.consolidatedData.outstandingBalance || 0) : 0;
        }

        // Calculate total due (what should be paid to be current)
        const totalDue = outstandingPrincipal + outstandingInterest + outstandingPenalty;
        
        // Calculate recommended payment (at least one term payment if behind)
        let recommendedPayment = 0;
        if (termsDue > 0) {
            const termsBehind = Math.max(0, termsDue - Math.floor((totalPaidPrincipal + totalPaidInterest) / (principalPerTerm + interestPerTerm)));
            recommendedPayment = Math.max(
                principalPerTerm + interestPerTerm, // At least one term payment
                (principalPerTerm + interestPerTerm) * Math.min(termsBehind, 3) + outstandingPenalty // Catch up payment (max 3 terms)
            );
        }

        // Check if loan is completed
        const totalExpectedPrincipal = amountGranted;
        const totalExpectedInterest = advanceInterest ? 
            (initialInterest * loanTerm) - initialInterest : 
            initialInterest * loanTerm;
        
        const isCompleted = loan.is_paid === true || loan.is_paid === 1 || 
                           (totalPaidPrincipal >= totalExpectedPrincipal && 
                            totalPaidInterest >= totalExpectedInterest);

        return {
            // Current outstanding amounts
            principal: outstandingPrincipal,
            interest: outstandingInterest,
            penalty: outstandingPenalty,
            totalDue: totalDue,
            
            // Payment recommendations
            recommendedPayment: recommendedPayment,
            minimumPayment: Math.max(principalPerTerm + interestPerTerm, outstandingPenalty),
            
            // Progress tracking
            termsDue: termsDue,
            termsPaid: Math.floor((totalPaidPrincipal + totalPaidInterest) / (principalPerTerm + interestPerTerm)),
            
            // Historical data
            totalPaid: totalPaid,
            totalPaidPrincipal: totalPaidPrincipal,
            totalPaidInterest: totalPaidInterest,
            totalPaidPenalty: totalPaidPenalty,
            
            // Expected totals
            totalExpectedPrincipal: totalExpectedPrincipal,
            totalExpectedInterest: totalExpectedInterest,
            expectedByDate: expectedPrincipalByDate + expectedInterestByDate,
            
            // Loan status
            isCompleted: isCompleted,
            isCurrent: totalDue <= 0.01,
            
            // Per-term amounts for reference
            principalPerTerm: principalPerTerm,
            interestPerTerm: interestPerTerm
        };
    }, [interestRate]);

    // Recompute outstanding when the payment date changes (as-of logic)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (!paymentDate || !currentLoan) return;
        const asOf = new Date(paymentDate);
        try {
            const enhanced = calculateActualOutstanding(currentLoan, paymentHistory, penaltyData, asOf);
            setOutstandingAmounts(prev => ({
                ...prev,
                principal: enhanced.principal,
                interest: enhanced.interest,
                penalty: enhanced.penalty,
                totalDue: enhanced.totalDue,
                isCompleted: enhanced.isCompleted,
                isCurrent: enhanced.isCurrent,
                recommendedPayment: enhanced.recommendedPayment,
                minimumPayment: enhanced.minimumPayment,
                termsDue: enhanced.termsDue,
                termsPaid: enhanced.termsPaid,
                expectedByDate: enhanced.expectedByDate,
                totalExpectedPrincipal: enhanced.totalExpectedPrincipal,
                totalExpectedInterest: enhanced.totalExpectedInterest,
                totalPaidPrincipal: enhanced.totalPaidPrincipal,
                totalPaidInterest: enhanced.totalPaidInterest,
                principalPerTerm: enhanced.principalPerTerm,
                interestPerTerm: enhanced.interestPerTerm,
                totalPaid: enhanced.totalPaid
            }));
        } catch (err) {
            // do nothing
        }
    }, [paymentDate, currentLoan, paymentHistory, penaltyData, calculateActualOutstanding]);

    // Function to fetch payment history and calculate outstanding amounts
    const fetchPaymentHistory = useCallback(async (loanId, loanData) => {
        try {
            const response = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/payments/fetch/by-loan/${loanId}`);
            const payments = response.data;
            setPaymentHistory(payments);
            if (loanData) setCurrentLoan(loanData);
            
            // Fetch penalty data for this loan
            const penalties = await fetchPenaltyData(loanId);
            
            // Calculate enhanced outstanding amounts using current date; date-specific recompute is handled separately
            const enhancedOutstanding = calculateActualOutstanding(loanData, payments, penalties, new Date());
            
            // Update outstanding amounts with enhanced calculation
            setOutstandingAmounts({
                principal: enhancedOutstanding.principal,
                interest: enhancedOutstanding.interest,
                penalty: enhancedOutstanding.penalty,
                totalDue: enhancedOutstanding.totalDue,
                totalPaid: enhancedOutstanding.totalPaid,
                isCompleted: enhancedOutstanding.isCompleted,
                isCurrent: enhancedOutstanding.isCurrent,
                
                // Enhanced fields
                recommendedPayment: enhancedOutstanding.recommendedPayment,
                minimumPayment: enhancedOutstanding.minimumPayment,
                termsDue: enhancedOutstanding.termsDue,
                termsPaid: enhancedOutstanding.termsPaid,
                expectedByDate: enhancedOutstanding.expectedByDate,
                
                // Keep existing fields for compatibility
                totalExpectedPrincipal: enhancedOutstanding.totalExpectedPrincipal,
                totalExpectedInterest: enhancedOutstanding.totalExpectedInterest,
                totalPaidPrincipal: enhancedOutstanding.totalPaidPrincipal,
                totalPaidInterest: enhancedOutstanding.totalPaidInterest,
                
                // Per-term amounts
                principalPerTerm: enhancedOutstanding.principalPerTerm,
                interestPerTerm: enhancedOutstanding.interestPerTerm
            });

            // Phase 3: Generate payment schedule and projections
            const schedule = generatePaymentSchedule(loanData, new Date(loanData.dateGranted));
            setPaymentSchedule(schedule);
            
            // Calculate what-if scenarios using the fresh outstanding snapshot
            const scenarios = calculateWhatIfScenarios(enhancedOutstanding);
            setWhatIfScenarios(scenarios);
            
        } catch (error) {
            console.error('Error fetching payment history:', error);
            setPaymentHistory([]);
            setOutstandingAmounts({
                principal: 0,
                interest: 0,
                penalty: 0,
                totalDue: 0,
                totalPaid: 0,
                isCompleted: false,
                isCurrent: false,
                recommendedPayment: 0,
                minimumPayment: 0
            });
        }
    }, [calculateActualOutstanding, fetchPenaltyData, generatePaymentSchedule, calculateWhatIfScenarios]);

    // Recompute analytics when outstanding amounts change
    useEffect(() => {
        const scenarios = calculateWhatIfScenarios();
        setWhatIfScenarios(scenarios);
    }, [calculateWhatIfScenarios, outstandingAmounts]);

    const handlePaymentTypeChange = (e) => {
        setPaymentType(e.target.value);
        setPaymentTypeError(false);
        handleChangeInput(e);
    };

    // Separate effect for initial loan loading (when id is present)
    useEffect(() => {
        if (id) {
            const fetchApplication = async () => {
                try {
                    setLoading(true);
                    const response = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/loan-processing/${id}`);
                    const loans = response.data;
                    
                    setInterestRate(loans.interestRate);
                    setCurrentLoan(loans);
                    setLoanDetails({
                        amountGranted: parseFloat(loans.amountGranted),
                        loanTerm: parseInt(loans.loanTerm),
                        advanceInterest: loans.advanceInterest
                    });
                    // Inline initial data load to avoid fetchPaymentHistory dependency loops
                    const paymentsRes = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/payments/fetch/by-loan/${id}`);
                    const payments = paymentsRes.data;
                    setPaymentHistory(payments);
                    const penalties = await fetchPenaltyData(id);

                    const enhanced = calculateActualOutstanding(loans, payments, penalties, new Date());
                    setOutstandingAmounts({
                        principal: enhanced.principal,
                        interest: enhanced.interest,
                        penalty: enhanced.penalty,
                        totalDue: enhanced.totalDue,
                        totalPaid: enhanced.totalPaid,
                        isCompleted: enhanced.isCompleted,
                        isCurrent: enhanced.isCurrent,
                        recommendedPayment: enhanced.recommendedPayment,
                        minimumPayment: enhanced.minimumPayment,
                        termsDue: enhanced.termsDue,
                        termsPaid: enhanced.termsPaid,
                        expectedByDate: enhanced.expectedByDate,
                        totalExpectedPrincipal: enhanced.totalExpectedPrincipal,
                        totalExpectedInterest: enhanced.totalExpectedInterest,
                        totalPaidPrincipal: enhanced.totalPaidPrincipal,
                        totalPaidInterest: enhanced.totalPaidInterest,
                        principalPerTerm: enhanced.principalPerTerm,
                        interestPerTerm: enhanced.interestPerTerm
                    });

                    const schedule = generatePaymentSchedule(loans, new Date(loans.dateGranted));
                    setPaymentSchedule(schedule);
                    
                    const addtl = `[${loans.loanProcessingType} - ₱${parseFloat(loans.amountGranted).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')} - ${format(new Date(loans.dateGranted), 'MM/dd/yyyy')}]`;

                    setValue(`${loans.applicant.lastName}, ${loans.applicant.firstName} ${loans.applicant.middleName} ${addtl}`);
                    setOptions([{ label: `${loans.applicant.lastName}, ${loans.applicant.firstName} ${loans.applicant.middleName} ${addtl}`, value: loans.id }]);
                } catch (error) {
                    if (error.response && error.response.status === 404) {
                        navigate('/dashboard');
                    } else {
                        console.error('Error retrieving loans:', error);
                    }
                } finally {
                    setLoading(false);
                }
            };
            fetchApplication();
        }
    }, [id, navigate, fetchPenaltyData, calculateActualOutstanding, generatePaymentSchedule]);

    // Separate effect for search options (when typing in search field)
    useEffect(() => {
        if (!id && value) { // Only fetch options when not loading by ID and there's a search value
            let source = axios.CancelToken.source();

            const fetchOptions = async () => {
                try {
                    setLoading(true);
                    setOptions([]); // Clear previous options while loading
                    
                    const response = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/loansearch?query=${value}&limit=10&bal=1`, {
                        cancelToken: source.token
                    });
                    const data = response.data;

                    if (data && data.rows) {
                        const suggestions = data.rows.map(loans => ({
                            label: `${loans.applicant.lastName}, ${loans.applicant.firstName} ${loans.applicant.middleName} [${loans.loanProcessingType} - ₱${parseFloat(loans.amountGranted).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')} - ${format(new Date(loans.dateGranted), 'MM/dd/yyyy')}]`,
                            value: loans.id
                        }));
                        setOptions(suggestions);
                    } else {
                        console.error('Invalid response structure:', data);
                        setOptions([]);
                    }
                } catch (error) {
                    if (!axios.isCancel(error)) {
                        console.error('Error fetching suggestions:', error);
                        setOptions([]);
                    }
                } finally {
                    setLoading(false);
                }
            };

            const timeoutId = setTimeout(fetchOptions, 300); // Add debouncing

            return () => {
                clearTimeout(timeoutId);
                source.cancel();
            };
        }
    }, [value, id]);

    useEffect(() => {
        if (id && !hasLoaded) { 
            setFormData(prevFormData => ({ ...prevFormData, loanProcessingID: id }));
            setHasLoaded(true);
        }
    }, [id, hasLoaded]);


    const handleChange = async (selectedOption) => {
        setValue(selectedOption ? selectedOption.label : '');
        setFormData({ ...formData, loanProcessingID: selectedOption.value });
        
        // Fetch loan details when an option is selected
        if (selectedOption) {
            try {
                setLoading(true);
                const response = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/loan-processing/${selectedOption.value}`);
                const loan = response.data;
                
                // Set the interest rate
                setInterestRate(loan.interestRate);
                setCurrentLoan(loan);
                setLoanDetails({
                    amountGranted: parseFloat(loan.amountGranted),
                    loanTerm: parseInt(loan.loanTerm),
                    advanceInterest: loan.advanceInterest
                });
                
                // Fetch payment history for this loan
                await fetchPaymentHistory(selectedOption.value, loan);
                
                // Reset payment fields
                setFormData(prevState => ({
                    ...prevState,
                    loanProcessingID: selectedOption.value,
                    paidTotal: '',
                    paidPrincipal: '',
                    paidInterest: '',
                    paidPenalty: '',
                    paidOther: ''
                }));
                
            } catch (error) {
                console.error('Error fetching loan details:', error);
            } finally {
                setLoading(false);
            }
        }
    };

    // Update the handleChangeInput function with proper payment allocation logic
    const handleChangeInput = (e) => {
        const { name, value } = e.target;
        
        if (name === 'paidTotal') {
            setPaidTotalError(!value);
            
            // If no loan is selected or value is empty, reset all fields
            if (!formData.loanProcessingID || !loanDetails.amountGranted || !value) {
                setFormData(prevState => ({
                    ...prevState,
                    paidTotal: value,
                    paidPrincipal: '',
                    paidInterest: '',
                    paidPenalty: '',
                    paidOther: ''
                }));
                return;
            }

            const paidTotal = parseFloat(value);
            if (isNaN(paidTotal) || paidTotal <= 0) {
                setFormData(prevState => ({
                    ...prevState,
                    paidTotal: value,
                    paidPrincipal: '',
                    paidInterest: '',
                    paidPenalty: '',
                    paidOther: ''
                }));
                return;
            }

            // Calculate allocation using enhanced business rules
            const allocation = calculatePaymentAllocation(paidTotal);

            setFormData(prevState => ({
                ...prevState,
                paidTotal: parseFloat(paidTotal.toFixed(2)),
                paidPrincipal: allocation.principal,
                paidInterest: allocation.interest,
                paidPenalty: allocation.penalty,
                paidOther: allocation.other
            }));
            
        } else if (name === 'paidPrincipal' || name === 'paidInterest' || name === 'paidOther' || name === 'paidPenalty') {
            const newValue = parseFloat(value) || 0;
            const updatedFormData = {
                ...formData,
                [name]: value === '' ? '' : newValue
            };
            
            // Calculate total from individual components
            const newTotal = 
                parseFloat(name === 'paidPrincipal' ? value : formData.paidPrincipal || 0) +
                parseFloat(name === 'paidInterest' ? value : formData.paidInterest || 0) +
                parseFloat(name === 'paidOther' ? value : formData.paidOther || 0) +
                parseFloat(name === 'paidPenalty' ? value : formData.paidPenalty || 0);

            // Update form data with manual changes
            setFormData({
                ...updatedFormData,
                paidTotal: newTotal || ''
            });
            
            // If penalty was changed manually and we have a valid total, recalculate allocation
            if (name === 'paidPenalty' && formData.loanProcessingID && loanDetails.amountGranted > 0 && newTotal > 0) {
                // Recalculate allocation with the new penalty value
                const allocation = calculatePaymentAllocation(newTotal, newValue);
                setFormData(prevState => ({
                    ...prevState,
                    paidTotal: parseFloat(newTotal.toFixed(2)),
                    paidPrincipal: allocation.principal,
                    paidInterest: allocation.interest,
                    paidPenalty: allocation.penalty,
                    paidOther: allocation.other
                }));
            } else if ((name === 'paidPrincipal' || name === 'paidInterest' || name === 'paidOther') && 
                       formData.loanProcessingID && loanDetails.amountGranted > 0 && newTotal > 0) {
                // For other manual changes, validate against outstanding amounts and warn if necessary
                const outstandingInterest = Math.max(0, outstandingAmounts.interest || 0);
                const outstandingPrincipal = Math.max(0, outstandingAmounts.principal || 0);
                
                // Optional: Add validation warnings for manual overrides
                if (name === 'paidInterest' && newValue > outstandingInterest && outstandingInterest > 0) {
                    console.warn(`Interest payment (${newValue}) exceeds outstanding interest (${outstandingInterest})`);
                }
                if (name === 'paidPrincipal' && newValue > outstandingPrincipal && outstandingPrincipal > 0) {
                    console.warn(`Principal payment (${newValue}) exceeds outstanding principal (${outstandingPrincipal})`);
                }
            }
        } else {
            setFormData(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    };

    // Function to calculate payment allocation based on business rules
    const calculatePaymentAllocation = (totalPayment, manualPenalty = null) => {
        // Return empty allocation if no loan selected or no payment amount
        if (!formData.loanProcessingID || !loanDetails.amountGranted || !totalPayment || totalPayment <= 0) {
            return {
                interest: 0,
                principal: 0,
                penalty: 0,
                other: 0
            };
        }

        // Get actual outstanding amounts from enhanced calculation
        const outstandingInterest = Math.max(0, outstandingAmounts.interest || 0);
        const outstandingPrincipal = Math.max(0, outstandingAmounts.principal || 0);
        const outstandingPenalty = Math.max(0, outstandingAmounts.penalty || 0);
        
        // For completed loans, limit allocation to exact outstanding amounts
        if (outstandingAmounts.isCompleted) {
            const remainingDebt = outstandingInterest + outstandingPrincipal + outstandingPenalty;
            if (remainingDebt <= 0.01) {
                // Loan is fully paid, put everything in "Other"
                return {
                    interest: 0,
                    principal: 0,
                    penalty: 0,
                    other: totalPayment
                };
            }
        }

        // Business Rule: Interest (due) → Principal (due) → Penalty → Other (priority allocation order)
        let remainingAmount = totalPayment;
        let allocatedInterest = 0;
        let allocatedPrincipal = 0;
        let allocatedPenalty = 0;
        let allocatedOther = 0;

        // Step 1: Allocate to Outstanding Interest first (highest priority)
        if (remainingAmount > 0 && outstandingInterest > 0) {
            // For interest, use the actual outstanding amount
            // Allow overpayment for catch-up scenarios, but prioritize outstanding first
            allocatedInterest = Math.min(remainingAmount, outstandingInterest);
            remainingAmount -= allocatedInterest;
        }

        // Step 2: Allocate to Outstanding Principal second
        if (remainingAmount > 0 && outstandingPrincipal > 0) {
            // For principal, use the actual outstanding amount
            allocatedPrincipal = Math.min(remainingAmount, outstandingPrincipal);
            remainingAmount -= allocatedPrincipal;
        }

        // Step 3: Handle Penalty (preserve manual input or use outstanding penalty)
        const targetPenalty = manualPenalty !== null ? manualPenalty : Math.min(remainingAmount, outstandingPenalty);
        
        if (targetPenalty > 0) {
            if (remainingAmount >= targetPenalty) {
                allocatedPenalty = targetPenalty;
                remainingAmount -= targetPenalty;
            } else {
                // Handle penalty shortfall scenario
                const penaltyShortfall = targetPenalty - remainingAmount;
                allocatedPenalty = remainingAmount;
                remainingAmount = 0;

                // Take from principal first, then interest (reverse order for shortfall)
                if (allocatedPrincipal >= penaltyShortfall) {
                    allocatedPenalty += penaltyShortfall;
                    allocatedPrincipal -= penaltyShortfall;
                } else {
                    allocatedPenalty += allocatedPrincipal;
                    const remainingShortfall = penaltyShortfall - allocatedPrincipal;
                    allocatedPrincipal = 0;

                    if (allocatedInterest >= remainingShortfall) {
                        allocatedPenalty += remainingShortfall;
                        allocatedInterest -= remainingShortfall;
                    } else {
                        allocatedPenalty += allocatedInterest;
                        allocatedInterest = 0;
                    }
                }
            }
        }

        // Step 4: Handle excess payment (when payment > outstanding amounts)
        if (remainingAmount > 0) {
            // If there's still outstanding interest beyond what we allocated, continue paying interest
            const remainingInterest = Math.max(0, outstandingInterest - allocatedInterest);
            if (remainingInterest > 0 && remainingAmount > 0) {
                const additionalInterest = Math.min(remainingAmount, remainingInterest);
                allocatedInterest += additionalInterest;
                remainingAmount -= additionalInterest;
            }

            // If there's still outstanding principal beyond what we allocated, continue paying principal
            const remainingPrincipal = Math.max(0, outstandingPrincipal - allocatedPrincipal);
            if (remainingPrincipal > 0 && remainingAmount > 0) {
                const additionalPrincipal = Math.min(remainingAmount, remainingPrincipal);
                allocatedPrincipal += additionalPrincipal;
                remainingAmount -= additionalPrincipal;
            }

            // Any remaining amount goes to "Other" (could be advance payments, fees, etc.)
            allocatedOther = remainingAmount;
        }

        // Validate total matches and make micro-adjustments if needed
        const calculatedTotal = allocatedInterest + allocatedPrincipal + allocatedPenalty + allocatedOther;
        const difference = totalPayment - calculatedTotal;
        
        if (Math.abs(difference) > 0.001) {
            // Adjust "Other" to make totals match exactly (handle floating point precision)
            allocatedOther += difference;
        }

        return {
            interest: Math.max(0, parseFloat(allocatedInterest.toFixed(2))),
            principal: Math.max(0, parseFloat(allocatedPrincipal.toFixed(2))),
            penalty: Math.max(0, parseFloat(allocatedPenalty.toFixed(2))),
            other: Math.max(0, parseFloat(allocatedOther.toFixed(2)))
        };
    };

    // New function to fetch recent payments
    const fetchRecentPayments = useCallback(async (page) => {
        try {
            setRecentPaymentsLoading(true);
            const response = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/payments/fetch/all`, {
                params: {
                    page: page,
                    limit: paymentsPerPage,
                    endDate: format(new Date(), 'yyyy-MM-dd')
                }
            });

            setRecentPayments(response.data.rows);
            setTotalPayments(response.data.count);
            setTotalPages(Math.ceil(response.data.count / paymentsPerPage));
        } catch (error) {
            console.error('Error fetching recent payments:', error);
        } finally {
            setRecentPaymentsLoading(false);
        }
    }, [paymentsPerPage]);

    // Navigation for pagination
    const goToPage = (page) => {
        setCurrentPage(page);
    };

    const goToFirstPage = () => {
        setCurrentPage(1);
    };

    const goToLastPage = () => {
        setCurrentPage(totalPages);
    };

    const goToPrevPage = () => {
        setCurrentPage(prev => Math.max(prev - 1, 1));
    };

    const goToNextPage = () => {
        setCurrentPage(prev => Math.min(prev + 1, totalPages));
    };

    // Get page numbers to display
    const getPageNumbers = () => {
        const pages = [];
        const maxPagesToShow = 3;
        
        if (totalPages <= maxPagesToShow) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            if (currentPage <= 2) {
                pages.push(1, 2, 3, '...');
            } else if (currentPage >= totalPages - 1) {
                pages.push('...', totalPages - 2, totalPages - 1, totalPages);
            } else {
                pages.push('...', currentPage - 1, currentPage, currentPage + 1, '...');
            }
        }
        
        return pages;
    };

    // Add effect to fetch recent payments
    useEffect(() => {
        fetchRecentPayments(currentPage);
    }, [currentPage, fetchRecentPayments]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        let hasErrors = false;

        // Check all required fields
        if (!formData.loanProcessingID) {
            setLoanProcessingIDError(true);
            hasErrors = true;
        }

        if (!paymentDate) {
            setDateValidationError(true);
            hasErrors = true;
        }
        
        if (!formData.paymentType) {
            setPaymentTypeError(true);
            hasErrors = true;
        }
        
        if (!formData.paidTotal) {
            setPaidTotalError(true);
            hasErrors = true;
        }

        if (hasErrors) {
            return;
        }

        // Reset validation states
        setLoanProcessingIDError(false);
        setDateValidationError(false);
        setPaymentTypeError(false);
        setPaidTotalError(false);
        setShowSpinner(true);

        try {
            const response = await axios.post(`${GLOBALVAR['SERVER_ROOT']}/api/payments/add`, formData);
            console.log(response.data); // Display the message returned from the server

            if(id){
                navigate(`/loans/${formData.loanProcessingID}`);
            } else {
                // Refresh payment history for the current loan if one is selected
                if (formData.loanProcessingID && loanDetails.amountGranted) {
                    const loanResponse = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/loan-processing/${formData.loanProcessingID}`);
                    await fetchPaymentHistory(formData.loanProcessingID, loanResponse.data);
                }
                
                // Reset all form fields and states
                setFormData({
                    loanProcessingID: '',
                    paymentDate: '',
                    prNumber: '',
                    orNumber: '',
                    paymentType: '',
                    chequeNumber: '',
                    paidPrincipal: '',
                    paidInterest: '',
                    paidPenalty: '',
                    paidOther: '',
                    paidTotal: ''
                });
                setPaymentDate(null);
                setPaymentType('');
                setValue(''); // Clear the search input
                setOptions([]); // Clear the options
                
                // Reset payment history and outstanding amounts
                setPaymentHistory([]);
                setOutstandingAmounts({
                    principal: 0,
                    interest: 0,
                    totalPaid: 0,
                    isCompleted: false
                });
                
                // Reset Select component value explicitly
                const selectElement = document.querySelector('input[name="loanProcessingID"]');
                if (selectElement) {
                    selectElement.value = '';
                }
                setModalHeader('Success');
                setModalBody(response.data.message);
                handleShow();
                setShowSpinner(false);
                
                // Refresh the recent payments list
                fetchRecentPayments(1);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            setModalHeader('Validation Error');
            setModalBody('');

            const errorsArray = error.response.data.error.split(',\n');
            const filteredErrors = errorsArray.map(error => error.replace('notNull Violation: ', '')).filter(error => error.trim() !== '');
            setErrMessages(filteredErrors);
            handleShow();
            setShowSpinner(false);
        }
    };

    return (
        <>
            {showSpinner && (<LoadingSpinner />)}
            <NavMain slug="add-repayment" parent="2" />
            <HeaderMain slug="add-repayment" />
            <div className="main-content add-repayment">
                <Modal show={showModal} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title className={errMessages ? 'text-danger' : 'text-success'}>
                            {modalHeader}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {errMessages ? (
                            <ul className="error-list">
                                {errMessages.map((error, index) => (
                                    <li key={index} className="text-danger">
                                        {error.trim().replace('Validation error: ', '')}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <div className="text-center">
                                <i className="fa-solid fa-circle-check text-success fs-1 mb-3"></i>
                                <p>{modalBody}</p>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant={errMessages ? 'secondary' : 'primary'} onClick={handleClose}>
                            {errMessages ? 'Close' : 'OK'}
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Row>
                    <Col lg={8}>
                        <Form onSubmit={handleSubmit}>
                            <div className="form-section">
                                <h2 className="section-title">
                                    <i className="fa-solid fa-user"></i>
                                    Borrower Information
                                </h2>
                                <div className="select-wrapper">
                                    <Select
                                        options={options}
                                        isLoading={loading}
                                        onInputChange={setValue}
                                        onChange={handleChange}
                                        value={options.find(option => option.label === value)}
                                        placeholder="Type borrower's name..."
                                        isDisabled={!!id}
                                        name="loanProcessingID"
                                        className={`${loanProcessingIDError ? 'is-invalid' : ''}`}
                                    />
                                    {loanProcessingIDError && (
                                        <div className="invalid-feedback" style={{ display: 'block' }}>
                                            Please select a borrower
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Loan Information Display */}
                            {formData.loanProcessingID && loanDetails.amountGranted > 0 && (
                                <div className="form-section">
                                    <h2 className="section-title">
                                        <i className="fa-solid fa-info-circle"></i>
                                        Loan Information
                                    </h2>
                                    <div className="as-of-date text-muted small mb-2" style={{ textAlign: 'right' }}>
                                        As of {format(paymentDate || new Date(), 'MM/dd/yyyy')}
                                    </div>
                                    <Row className="mb-3">
                                        <Col md={3}>
                                            <div className="info-card">
                                                <div className="info-label">Amount Granted</div>
                                                <div className="info-value">₱{loanDetails.amountGranted.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</div>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="info-card">
                                                <div className="info-label">Interest Rate</div>
                                                <div className="info-value">{interestRate}%</div>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="info-card">
                                                <div className="info-label">Loan Term</div>
                                                <div className="info-value">{loanDetails.loanTerm} months</div>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="info-card">
                                                <div className="info-label">Interest Type</div>
                                                <div className="info-value">{loanDetails.advanceInterest ? 'Advance' : 'Regular'}</div>
                                            </div>
                                        </Col>
                                    </Row>
                                    
                                    {outstandingAmounts.totalPaid > 0 && (
                                        <>
                                            <Row className="mb-3">
                                                <Col md={3}>
                                                    <div className="info-card outstanding">
                                                        <div className="info-label">Outstanding Principal</div>
                                                        <div className="info-value text-warning">₱{outstandingAmounts.principal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</div>
                                                    </div>
                                                </Col>
                                                <Col md={3}>
                                                    <div className="info-card outstanding">
                                                        <div className="info-label">Outstanding Interest</div>
                                                        <div className="info-value text-warning">₱{outstandingAmounts.interest.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</div>
                                                    </div>
                                                </Col>
                                                <Col md={3}>
                                                    <div className="info-card outstanding">
                                                        <div className="info-label">Outstanding Penalties</div>
                                                        <div className="info-value text-danger">₱{(outstandingAmounts.penalty || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</div>
                                                    </div>
                                                </Col>
                                                <Col md={3}>
                                                    <div className="info-card outstanding">
                                                        <div className="info-label">Total Due</div>
                                                        <div className="info-value text-danger">₱{(outstandingAmounts.totalDue || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</div>
                                                    </div>
                                                </Col>
                                            </Row>
                                            
                                            <Row className="mb-3">
                                                <Col md={3}>
                                                    <div className="info-card payment-status">
                                                        <div className="info-label">Payment Status</div>
                                                        <div className={`info-value ${
                                                            outstandingAmounts.isCompleted ? 'text-success' : 
                                                            outstandingAmounts.isCurrent ? 'text-info' : 'text-warning'
                                                        }`}>
                                                            {outstandingAmounts.isCompleted ? 'Completed' : 
                                                             outstandingAmounts.isCurrent ? 'Current' : 'Behind'}
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col md={3}>
                                                    <div className="info-card">
                                                        <div className="info-label">Terms Due</div>
                                                        <div className="info-value">{outstandingAmounts.termsDue || 0} of {loanDetails.loanTerm}</div>
                                                    </div>
                                                </Col>
                                                <Col md={3}>
                                                    <div className="info-card">
                                                        <div className="info-label">Terms Paid</div>
                                                        <div className="info-value text-success">{outstandingAmounts.termsPaid || 0}</div>
                                                    </div>
                                                </Col>
                                                <Col md={3}>
                                                    <div className="info-card">
                                                        <div className="info-label">Total Paid</div>
                                                        <div className="info-value text-success">₱{outstandingAmounts.totalPaid.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</div>
                                                    </div>
                                                </Col>
                                            </Row>
                                            
                                            {/* Payment Recommendations removed as requested */}
                                        </>
                                    )}
                                </div>
                            )}

                            {/* Message when no borrower is selected */}
                            {!formData.loanProcessingID && (
                                <div className="form-section">
                                    <div className="no-borrower-message">
                                        <div className="message-content">
                                            <i className="fa-solid fa-user-plus"></i>
                                            <h5>Select a Borrower to Continue</h5>
                                            <p>Please select a borrower from the search field above to access payment details and processing options.</p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {formData.loanProcessingID && loanDetails.amountGranted > 0 && (
                                <div className="form-section">
                                    <h2 className="section-title">
                                        <i className="fa-solid fa-receipt"></i>
                                        Payment Details
                                    </h2>
                                    <Row className="mb-3">
                                        <Col md={4}>
                                            <FloatingLabel controlId="floatingPrNumber" label="PR Number">
                                                <Form.Control 
                                                    type="text"
                                                    placeholder="PR Number" 
                                                    name="prNumber" 
                                                    onChange={handleChangeInput}
                                                    value={formData.prNumber}
                                                />
                                            </FloatingLabel>
                                        </Col>
                                        <Col md={4}>
                                            <FloatingLabel controlId="floatingOrNumber" label="OR Number">
                                                <Form.Control 
                                                    type="text"
                                                    placeholder="OR Number" 
                                                    name="orNumber" 
                                                    onChange={handleChangeInput}
                                                    value={formData.orNumber}
                                                />
                                            </FloatingLabel>
                                        </Col>
                                        <Col md={4}>
                                            <div className="date-picker-wrapper">
                                                <FloatingLabel controlId="floatingPaymentDate" label="Payment Date *">
                                                    <DatePicker
                                                        className={`form-control ${dateValidationError ? 'is-invalid' : ''}`}
                                                        selected={paymentDate}
                                                        onChange={handleDateChange}
                                                        dateFormat="MM/dd/yyyy"
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        name="paymentDate"
                                                        maxDate={new Date()}
                                                        placeholderText=" "  // Change this to a space
                                                        autoComplete="off"
                                                        required
                                                    />
                                                    {dateValidationError && (
                                                        <div className="invalid-feedback">
                                                            Payment date is required
                                                        </div>
                                                    )}
                                                </FloatingLabel>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Col md={6}>
                                            <FloatingLabel controlId="floatingPaymentType" label="Payment Type *">
                                                <Form.Select 
                                                    name="paymentType" 
                                                    value={paymentType}
                                                    onChange={handlePaymentTypeChange}
                                                    onBlur={handlePaymentTypeChange}
                                                    isInvalid={paymentTypeError}
                                                >
                                                    <option value="">Select Payment Type</option>
                                                    <option value="cash">Cash</option>
                                                    <option value="cheque">Cheque</option>
                                                </Form.Select>
                                                {paymentTypeError && (
                                                    <Form.Control.Feedback type="invalid">
                                                        Payment type is required
                                                    </Form.Control.Feedback>
                                                )}
                                            </FloatingLabel>
                                        </Col>
                                        {paymentType === 'cheque' && (
                                            <Col md={6}>
                                                <FloatingLabel controlId="floatingChequeNumber" label="Cheque Number *">
                                                    <Form.Control 
                                                        type="text" 
                                                        placeholder="Cheque Number" 
                                                        name="chequeNumber" 
                                                        onChange={handleChangeInput}
                                                        value={formData.chequeNumber}
                                                        required
                                                    />
                                                </FloatingLabel>
                                            </Col>
                                        )}
                                    </Row>
                                </div>
                            )}

                            {formData.loanProcessingID && loanDetails.amountGranted > 0 && (
                                <div className="form-section">
                                    <h2 className="section-title">
                                        <i className="fa-solid fa-calculator"></i>
                                        Payment Breakdown
                                    </h2>
                                    
                                    <div className="payment-breakdown-note">
                                        <i className="fa-solid fa-info-circle"></i>
                                        Payment amounts are automatically allocated based on actual outstanding amounts and due dates. 
                                        Priority: <strong>Interest (due) → Principal (due) → Penalties → Other</strong>. 
                                        You can manually adjust individual amounts if needed.
                                    </div>

                                    {/* Quick Payment Options */}
                                    {!outstandingAmounts.isCompleted && (outstandingAmounts.totalDue > 0 || outstandingAmounts.penalty > 0) && (
                                        <div className="quick-payment-options mb-3">
                                            <h6 className="mb-2">
                                                <i className="fa-solid fa-zap me-2"></i>
                                                Quick Payment Options
                                            </h6>
                                            <div className="quick-options-grid">
                                                {outstandingAmounts.penalty > 0 && (
                                                    <Button 
                                                        variant="outline-danger" 
                                                        size="sm"
                                                        onClick={() => {
                                                            const penaltyAmount = Number((outstandingAmounts.penalty || 0).toFixed(2));
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                paidTotal: penaltyAmount,
                                                                paidPenalty: penaltyAmount,
                                                                paidInterest: 0,
                                                                paidPrincipal: 0,
                                                                paidOther: 0
                                                            }));
                                                        }}
                                                    >
                                                        <i className="fa-solid fa-triangle-exclamation me-1"></i>
                                                        Pay Penalties Only (₱{outstandingAmounts.penalty.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
                                                    </Button>
                                                )}
                                                
                                                {outstandingAmounts.totalDue > 0 && (
                                                    <Button 
                                                        variant="outline-warning" 
                                                        size="sm"
                                                        onClick={() => {
                                                            const totalDue = outstandingAmounts.totalDue;
                                                            handleChangeInput({ target: { name: 'paidTotal', value: totalDue.toString() } });
                                                        }}
                                                    >
                                                        <i className="fa-solid fa-clock-rotate-left me-1"></i>
                                                        Pay All Due (₱{outstandingAmounts.totalDue.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
                                                    </Button>
                                                )}

                                                {outstandingAmounts.interestPerTerm && outstandingAmounts.principalPerTerm && (
                                                    <Button 
                                                        variant="outline-primary" 
                                                        size="sm"
                                                        onClick={() => {
                                                            const termPayment = outstandingAmounts.interestPerTerm + outstandingAmounts.principalPerTerm;
                                                            handleChangeInput({ target: { name: 'paidTotal', value: termPayment.toString() } });
                                                        }}
                                                    >
                                                        <i className="fa-solid fa-calendar-check me-1"></i>
                                                        One Term Payment (₱{(outstandingAmounts.interestPerTerm + outstandingAmounts.principalPerTerm).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
                                                    </Button>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                    
                                    <Row className="mb-3">
                                        <Col md={6}>
                                            <FloatingLabel controlId="floatingPaidTotal" label="Total Payment Amount *">
                                                <Form.Control 
                                                    type="number" 
                                                    step="any"
                                                    placeholder="Total Payment Amount" 
                                                    name="paidTotal" 
                                                    value={formData.paidTotal === '' ? '' : formData.paidTotal}
                                                    onChange={handleChangeInput}
                                                    isInvalid={paidTotalError}
                                                    required
                                                />
                                                {paidTotalError && (
                                                    <Form.Control.Feedback type="invalid">
                                                        Payment amount is required
                                                    </Form.Control.Feedback>
                                                )}
                                            </FloatingLabel>
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Col md={3}>
                                            <FloatingLabel controlId="floatingPaidInterest" label="Interest Payment">
                                                <Form.Control 
                                                    type="number" 
                                                    step="any"
                                                    placeholder="Interest Payment" 
                                                    name="paidInterest" 
                                                    value={formData.paidInterest === '' ? '' : formData.paidInterest}
                                                    onChange={handleChangeInput}
                                                />
                                            </FloatingLabel>
                                        </Col>
                                        <Col md={3}>
                                            <FloatingLabel controlId="floatingPaidPrincipal" label="Principal Payment">
                                                <Form.Control 
                                                    type="number" 
                                                    step="any"
                                                    placeholder="Principal Payment" 
                                                    name="paidPrincipal" 
                                                    value={formData.paidPrincipal === '' ? '' : formData.paidPrincipal}
                                                    onChange={handleChangeInput}
                                                />
                                            </FloatingLabel>
                                        </Col>
                                        <Col md={3}>
                                            <FloatingLabel controlId="floatingPaidPenalty" label="Penalty Payment">
                                                <Form.Control 
                                                    type="number" 
                                                    step="any"
                                                    placeholder="Penalty Payment" 
                                                    name="paidPenalty"
                                                    value={formData.paidPenalty === '' ? '' : formData.paidPenalty}
                                                    onChange={handleChangeInput}
                                                />
                                            </FloatingLabel>
                                        </Col>
                                        <Col md={3}>
                                            <FloatingLabel controlId="floatingPaidOther" label="Other Charges">
                                                <Form.Control 
                                                    type="number" 
                                                    step="any"
                                                    placeholder="Other Charges" 
                                                    name="paidOther"
                                                    value={formData.paidOther === '' ? '' : formData.paidOther}
                                                    onChange={handleChangeInput}
                                                />
                                            </FloatingLabel>
                                        </Col>
                                    </Row>
                                    
                                    {/* Payment Impact Preview */}
                                    {formData.paidTotal && parseFloat(formData.paidTotal) > 0 && (
                                        <div className="payment-impact-preview mt-3">
                                            <h6 className="mb-3">
                                                <i className="fa-solid fa-chart-line me-2"></i>
                                                Payment Impact Preview
                                            </h6>
                                            <Row>
                                                <Col md={6}>
                                                    <div className="impact-card">
                                                        <h6>After This Payment</h6>
                                                        <div className="impact-details">
                                                            <div className="impact-item">
                                                                <span className="label">Remaining Principal:</span>
                                                                <span className="value">₱{Math.max(0, (outstandingAmounts.principal || 0) - parseFloat(formData.paidPrincipal || 0)).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span>
                                                            </div>
                                                            <div className="impact-item">
                                                                <span className="label">Remaining Interest:</span>
                                                                <span className="value">₱{Math.max(0, (outstandingAmounts.interest || 0) - parseFloat(formData.paidInterest || 0)).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span>
                                                            </div>
                                                            <div className="impact-item">
                                                                <span className="label">Remaining Penalties:</span>
                                                                <span className="value">₱{Math.max(0, (outstandingAmounts.penalty || 0) - parseFloat(formData.paidPenalty || 0)).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col md={6}>
                                                    <div className="impact-card">
                                                        <h6>Payment Status</h6>
                                                        <div className="impact-details">
                                                            {(() => {
                                                                const remainingDue = Math.max(0, 
                                                                    (outstandingAmounts.totalDue || 0) - parseFloat(formData.paidTotal || 0)
                                                                );
                                                                const willBeCurrent = remainingDue <= 0.01;
                                                                
                                                                return (
                                                                    <>
                                                                        <div className="impact-item">
                                                                            <span className="label">New Status:</span>
                                                                            <span className={`value ${willBeCurrent ? 'text-success' : 'text-warning'}`}>
                                                                                {outstandingAmounts.isCompleted ? 'Completed' : 
                                                                                 willBeCurrent ? 'Current' : 'Behind'}
                                                                            </span>
                                                                        </div>
                                                                        <div className="impact-item">
                                                                            <span className="label">Remaining Due:</span>
                                                                            <span className="value">₱{remainingDue.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span>
                                                                        </div>
                                                                        {parseFloat(formData.paidTotal || 0) > (outstandingAmounts.totalDue || 0) && (
                                                                            <div className="impact-item">
                                                                                <span className="label">Overpayment:</span>
                                                                                <span className="value text-info">₱{(parseFloat(formData.paidTotal || 0) - (outstandingAmounts.totalDue || 0)).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span>
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                );
                                                            })()}
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    )}
                                    
                                    {/* Phase 3: Advanced Payment Features */}
                                    {formData.loanProcessingID && loanDetails.amountGranted > 0 && !outstandingAmounts.isCompleted && (
                                        <div className="advanced-payment-features mt-4">
                                            <div className="feature-tabs mb-3">
                                                <Button 
                                                    variant={showAnalytics ? "primary" : "outline-primary"} 
                                                    size="sm" 
                                                    className="me-2 mb-2"
                                                    onClick={handleAnalyticsToggle}
                                                >
                                                    <i className="fa-solid fa-chart-bar me-1"></i>
                                                    Payment Analytics
                                                </Button>
                                                <Button 
                                                    variant="outline-info" 
                                                    size="sm" 
                                                    className="me-2 mb-2"
                                                    onClick={handleShowSchedule}
                                                >
                                                    <i className="fa-solid fa-calendar me-1"></i>
                                                    Payment Schedule
                                                </Button>
                                                {/* Bulk Payments feature removed */}
                                            </div>

                                            {/* Payment Analytics Section */}
                                            {showAnalytics && whatIfScenarios.length > 0 && (
                                                <div className="payment-analytics mb-3">
                                                    <h6 className="mb-3">
                                                        <i className="fa-solid fa-calculator me-2"></i>
                                                        What-If Payment Scenarios
                                                    </h6>
                                                    <Row>
                                                        {whatIfScenarios.map((scenario, index) => (
                                                            <Col md={6} key={index} className="mb-3">
                                                                <div className="scenario-card" onClick={() => handleQuickScenario(scenario.payment)}>
                                                                    <div className="scenario-header">
                                                                        <strong>{scenario.name}</strong>
                                                                        <span className="badge bg-primary">₱{scenario.payment.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span>
                                                                    </div>
                                                                    <small className="text-muted">{scenario.description}</small>
                                                                    <div className="scenario-metrics">
                                                                        <small>
                                                                            <i className="fa-solid fa-calendar-days me-1"></i>
                                                                            {scenario.months} month{scenario.months !== 1 ? 's' : ''}
                                                                        </small>
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        ))}
                                                    </Row>
                                                </div>
                                            )}

                                            {/* Bulk Payments feature removed */}
                                        </div>
                                    )}
                                </div>
                            )}

                            {formData.loanProcessingID && loanDetails.amountGranted > 0 && (
                                <div className="form-actions">
                                    <Button 
                                        variant="primary" 
                                        type="submit" 
                                        className="submit-btn" 
                                        id="submit-processing"
                                    >
                                        <i className="fa-solid fa-paper-plane me-2"></i>
                                        Process Payment
                                    </Button>
                                </div>
                            )}
                        </Form>
                    </Col>
                    
                    <Col lg={4}>
                        <div className="recent-payments-section">
                            <Card>
                                <Card.Header>
                                    <h5 className="mb-0">
                                        <i className="fa-solid fa-clock-rotate-left me-2"></i>
                                        Recent Payments
                                    </h5>
                                </Card.Header>
                                <Card.Body>
                                    {recentPaymentsLoading ? (
                                        <div className="text-center p-4">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                            <p className="mt-2 text-muted">Loading recent payments...</p>
                                        </div>
                                    ) : (
                                        <>
                                            {recentPayments.length > 0 ? (
                                                <Table responsive className="recent-payments-table">
                                                    <thead>
                                                        <tr>
                                                            <th>Date</th>
                                                            <th>Borrower</th>
                                                            <th>Loan #</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {recentPayments.map((payment) => (
                                                            <tr key={payment.id}>
                                                                <td>{format(new Date(payment.paymentDate), 'MM/dd/yyyy')}</td>
                                                                <td>
                                                                    <a href={`/applicant/${payment.loanProcessing.applicant.id}`}>
                                                                        {payment.loanProcessing.applicant.lastName}, {payment.loanProcessing.applicant.firstName}
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <a href={`/loans/${payment.loanProcessing.id}`}>
                                                                        {payment.loanProcessingID.toString().padStart(6, '0')}
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            ) : (
                                                <div className="no-payments-message">
                                                    <div className="message-content">
                                                        <i className="fa-solid fa-receipt"></i>
                                                        <h6>No Payment Records</h6>
                                                        <p>No payments have been made yet.</p>
                                                    </div>
                                                </div>
                                            )}
                                            
                                            {recentPayments.length > 0 && (
                                                <div className="pagination-controls">
                                                    <div className="pagination-info">
                                                        Showing {Math.min((currentPage - 1) * paymentsPerPage + 1, totalPayments)} - 
                                                        {Math.min(currentPage * paymentsPerPage, totalPayments)} of {totalPayments}
                                                    </div>
                                                    <div className="pagination-buttons">
                                                        <Button 
                                                            variant="outline-secondary" 
                                                            size="sm" 
                                                            onClick={goToFirstPage} 
                                                            disabled={currentPage === 1}
                                                        >
                                                            <i className="fa-solid fa-angles-left"></i>
                                                        </Button>
                                                        <Button 
                                                            variant="outline-secondary" 
                                                            size="sm" 
                                                            onClick={goToPrevPage} 
                                                            disabled={currentPage === 1}
                                                        >
                                                            <i className="fa-solid fa-angle-left"></i>
                                                        </Button>
                                                        
                                                        {getPageNumbers().map((page, index) => (
                                                            <React.Fragment key={index}>
                                                                {page === '...' ? (
                                                                    <span className="mx-1">...</span>
                                                                ) : (
                                                                    <Button 
                                                                        variant={page === currentPage ? "primary" : "outline-secondary"}
                                                                        size="sm"
                                                                        onClick={() => goToPage(page)}
                                                                        disabled={page === currentPage}
                                                                        className="mx-1"
                                                                    >
                                                                        {page}
                                                                    </Button>
                                                                )}
                                                            </React.Fragment>
                                                        ))}
                                                        
                                                        <Button 
                                                            variant="outline-secondary" 
                                                            size="sm" 
                                                            onClick={goToNextPage} 
                                                            disabled={currentPage === totalPages}
                                                        >
                                                            <i className="fa-solid fa-angle-right"></i>
                                                        </Button>
                                                        <Button 
                                                            variant="outline-secondary" 
                                                            size="sm" 
                                                            onClick={goToLastPage} 
                                                            disabled={currentPage === totalPages}
                                                        >
                                                            <i className="fa-solid fa-angles-right"></i>
                                                        </Button>
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </Card.Body>
                            </Card>
                        </div>
                    </Col>
                </Row>
            </div>

            {/* Phase 3: Payment Schedule Modal */}
            <Modal 
                show={showScheduleModal} 
                onHide={() => setShowScheduleModal(false)} 
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="fa-solid fa-calendar me-2"></i>
                        Payment Schedule Preview
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {paymentSchedule.length > 0 ? (
                        <div className="payment-schedule-preview">
                            <div className="schedule-summary mb-3">
                                <Row>
                                    <Col md={4}>
                                        <div className="summary-item">
                                            <small className="text-muted">Total Terms</small>
                                            <div className="fw-bold">{paymentSchedule.length}</div>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="summary-item">
                                            <small className="text-muted">Terms Completed</small>
                                            <div className="fw-bold text-success">{outstandingAmounts.termsPaid || 0}</div>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="summary-item">
                                            <small className="text-muted">Terms Remaining</small>
                                            <div className="fw-bold text-warning">{paymentSchedule.length - (outstandingAmounts.termsPaid || 0)}</div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            
                            <div className="schedule-table-container">
                                <Table responsive striped className="schedule-table">
                                    <thead>
                                        <tr>
                                            <th>Term #</th>
                                            <th>Due Date</th>
                                            <th>Principal</th>
                                            <th>Interest</th>
                                            <th>Total Payment</th>
                                            <th>Remaining Balance</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paymentSchedule.map((term, index) => {
                                            const isPaid = index < (outstandingAmounts.termsPaid || 0);
                                            const isOverdue = new Date(term.dueDate) < new Date() && !isPaid;
                                            const isCurrent = index === (outstandingAmounts.termsPaid || 0);
                                            
                                            return (
                                                <tr key={index} className={`
                                                    ${isPaid ? 'table-success' : ''}
                                                    ${isOverdue ? 'table-danger' : ''}
                                                    ${isCurrent ? 'table-warning' : ''}
                                                `}>
                                                    <td className="fw-bold">{term.termNumber}</td>
                                                    <td>{format(term.dueDate, 'MMM dd, yyyy')}</td>
                                                    <td>₱{term.principal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                                                    <td>₱{term.interest.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                                                    <td className="fw-bold">₱{term.totalPayment.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                                                    <td>₱{term.remainingBalance.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                                                    <td>
                                                        {isPaid && <span className="badge bg-success">Paid</span>}
                                                        {isOverdue && <span className="badge bg-danger">Overdue</span>}
                                                        {isCurrent && <span className="badge bg-warning">Current</span>}
                                                        {!isPaid && !isOverdue && !isCurrent && <span className="badge bg-secondary">Future</span>}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    ) : (
                        <div className="text-center p-4">
                            <i className="fa-solid fa-calendar-xmark fa-3x text-muted mb-3"></i>
                            <p className="text-muted">No payment schedule available</p>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowScheduleModal(false)}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={() => {
                        setShowScheduleModal(false);
                        handleAnalyticsToggle();
                    }}>
                        <i className="fa-solid fa-chart-bar me-1"></i>
                        View Analytics
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default AddRepayment;